import { render, staticRenderFns } from "./EsportsIframe.vue?vue&type=template&id=aceb9b38&scoped=true"
import script from "./EsportsIframe.vue?vue&type=script&lang=js"
export * from "./EsportsIframe.vue?vue&type=script&lang=js"
import style0 from "./EsportsIframe.vue?vue&type=style&index=0&id=aceb9b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceb9b38",
  null
  
)

export default component.exports